import React from 'react';
import './Loader.css';

export const Loader = ({ children, ...props }) => {
    if (props.loading) {
        return <div className="loader"></div>;
    }

    return (children || null)
};


// WEBPACK FOOTER //
// ./src/components/Loader.js